var _ref;
import * as colors from './colors';
import * as spacing from './spacing';
import * as typography from './typography';
export const theme = {
    colors: {
        ...colors || {},
        list: (_ref = colors === null || colors === void 0 ? void 0 : colors.colors) !== null && _ref !== void 0 ? _ref : {}
    },
    typography,
    spacing
};
